// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings-module--container--2SJES"};